import classNames from "classnames"

import { TextButtonProps } from "@/types/components/button"
import "@/components/button/textButton.scss"

export default function TextButton({
  className,
  disabled,
  variant = "default",
  ...props
}: TextButtonProps) {
  const mergedClassName = classNames("TextButtonCont", className, variant, { disabled })

  return <button className={mergedClassName} {...props}></button>
}
